import { appointmentApi } from '@/config/axios/index';

export default {

  getAppointments() {
    return appointmentApi({
      method: 'GET',
      url: '/api/v1/agendamento/',
      data: null,
    });
  },

  getAppointmentData(appointmentId) {
    return appointmentApi({
      method: 'GET',
      url: `/api/v1/agendamento/${appointmentId}`,
      data: null,
    });
  },

  cancelAppointment(appointmentId) {
    return appointmentApi({
      method: 'POST',
      url: `/api/v1/agendamento/${appointmentId}/cancelar`,
      data: null,
    });
  },
};
